import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Menu, X, Activity } from "lucide-react";

const NAV = [
  { label: "Race", href: "#categories" },
  { label: "About", href: "#about" },
  { label: "Inclusions", href: "#inclusions" },
  { label: "Gallery", href: "#gallery" },
  { label: "FAQs", href: "#faqs" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <motion.header
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#0b1120]/80 border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="logo-home-link">
          <Activity className="h-7 w-7 text-[#FF4D00] group-hover:rotate-12 transition-transform" strokeWidth={2.5} />
          <span className="font-display text-2xl tracking-wide leading-none">COORG<span className="text-[#FF4D00]">·</span>INFINITY</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <a key={n.label} href={n.href}
               className="text-xs uppercase tracking-[0.18em] font-bold text-white/70 hover:text-[#FF4D00] transition-colors"
               data-testid={`nav-${n.label.toLowerCase()}`}>
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate("/register")}
            className="hidden sm:inline-flex items-center bg-[#FF4D00] hover:bg-[#FF6A22] text-white text-xs uppercase tracking-[0.18em] font-bold px-6 py-3 transition-colors active:scale-95"
            data-testid="header-register-button"
          >
            Register
          </button>
          <button className="lg:hidden text-white" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu" data-testid="mobile-menu-toggle">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0b1120] border-t border-white/10 px-5 py-6 flex flex-col gap-5" data-testid="mobile-menu">
          {NAV.map((n) => (
            <a key={n.label} href={n.href} onClick={() => setOpen(false)}
               className="text-sm uppercase tracking-[0.18em] font-bold text-white/80">
              {n.label}
            </a>
          ))}
          <button onClick={() => navigate("/register")}
                  className="bg-[#FF4D00] text-white text-xs uppercase tracking-[0.18em] font-bold px-6 py-3 mt-2">
            Register
          </button>
        </div>
      )}
    </motion.header>
  );
};
